import { SignIn } from '@clerk/clerk-react';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { PageURL } from 'router/pageURL';
import { AppFooter } from '../../components/AppFooter/AppFooter';
import { useEffect } from 'react';
import { config } from 'utils/config';
import { useAuth } from 'providers';

export const LoginPageProd = () => {
  const { isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSignedIn && isLoaded) {
      setTimeout(() => {
        navigate(PageURL.ROOT);
      }, 200);
    }
  }, [isLoaded, isSignedIn]);

  return isLoaded && !isSignedIn ? (
    <div className='min-h-screen grid grid-rows-[1fr_auto]'>
      <main>
        <Container component='div' className={`flex h-full flex-col justify-center`}>
          <div className={`flex justify-center`}>
            <div className='flex flex-col items-center gap-4'>
              <SignIn />
            </div>
          </div>
        </Container>
      </main>
      <AppFooter />
    </div>
  ) : (
    <></>
  );
};

export const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (config.isLocalAuth) {
      navigate(PageURL.ROOT);
    }
  }, [navigate]);

  if (config.isLocalAuth) {
    return (
      <div className='flex flex-col items-center justify-center p-8 text-gray-600'>
        <p>Local dev: you are signed in. Set VITE_USE_LOCAL_AUTH=false to use Clerk login.</p>
      </div>
    );
  }

  return <LoginPageProd />;
};
